import starred from './starred/reducer';
import repositories from './repositories/reducer';
import user from './user/reducer';

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
	starred,
	repositories,
	user,
});

export default rootReducer;
